import { useTranslation } from "react-i18next";
import * as z from "zod";
import { useAddressSchema } from "@hooks/schemas/useAddressSchema";
import { useHouseDetailsSchema } from "@hooks/schemas/useHouseDetailsSchema";

export const useEditHouseSchema = (
  isFakeAddress: boolean,
  validateAddress: boolean,
) => {
  const { t } = useTranslation();

  const addressSchema = useAddressSchema(
    "municipalityId",
    "settlementId",
    "streetId",
    "house",
    "apartment",
  );

  const houseDetailsSchema = useHouseDetailsSchema(
    "jointBillServiceTypeId",
    "area",
    "heatingTypeId",
  );

  return z
    .object({
      sortOrderAndDisplayName: z.object({
        orderNumber: z.optional(z.number()),
        displayName: z.optional(z.string()),
      }),
      jointBillServiceInformation: houseDetailsSchema.merge(
        z.object({
          firstName: z.string({
            required_error: t(
              "editHouseModal.form.fields.firstName.errors.required",
            ),
          }),
          lastName: z.string({
            required_error: t(
              "editHouseModal.form.fields.lastName.errors.required",
            ),
          }),
        }),
      ),
    })
    .merge(
      (isFakeAddress && validateAddress) || !isFakeAddress
        ? addressSchema
        : z.object({}),
    );
};
